var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBymTrafikkskilt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.599,
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square",
    d: "M16 1v1M16 16v12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M13.1 16L9 11.9V6.1l2.07-2.03L13.1 2h5.8L23 6.1v5.8L18.9 16z"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "OsloSans-Bold, OsloSans",
    fontSize: 4,
    fontWeight: "bold",
    letterSpacing: -0.04,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10.616,
    y: 10.5
  }, "STOP")), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M11 28h10v3H11z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M30 31H8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBymTrafikkskilt);
export default __webpack_public_path__ + "static/media/BYM_Trafikkskilt.961c7161.svg";
export { ForwardRef as ReactComponent };